import React from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Divider,
  Box,
} from "@mui/material";

const VendorSubscriptionPlan = ({
  plan,
  selected,
  onSelect,
  theme
}) => {
  const { name, property_limit, prices, project_limit } = plan;
  
  // Always use yearly price
  const yearlyPrice = prices.yearly || prices.Yearly;
  
  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={4}
      sx={{ display: "flex", justifyContent: "center" }}
    >
      <Card
        onClick={onSelect}
        sx={{
          cursor: "pointer",
          width: "100%",
          maxWidth: 320,
          backgroundColor: selected ? "#f5faff" : "#ffffff",
          border: selected ? "2px solid #1976d2" : "1px solid #e0e0e0",
          boxShadow: selected
            ? "0 4px 16px rgba(25, 118, 210, 0.12)"
            : "0 2px 8px rgba(0,0,0,0.05)",
          borderRadius: 2,
          transition: "all 0.25s ease-in-out",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          "&:hover": {
            boxShadow: "0 6px 20px rgba(25, 118, 210, 0.08)",
          },
        }}
      >
        <CardContent sx={{ px: 3, py: 4 }}>
          <Typography
            variant="h6"
            align="center"
            sx={{
              fontWeight: 600,
              color: selected ? "#1976d2" : "#222",
              textTransform: "uppercase",
              fontSize: "1.05rem",
              mb: 1,
            }}
          >
            {name}
          </Typography>

          <Typography
            variant="h4"
            align="center"
            sx={{
              fontWeight: 700,
              fontSize: "1.9rem",
              color: "#2e7d32",
              mb: 1,
            }}
          >
            ₹{yearlyPrice}
          </Typography>

          {/* Yearly Period Badge - Removed Selector */}
          <Box sx={{ display: "flex", justifyContent: "center", mt: 1.5 }}>
            <Typography
              variant="body2"
              sx={{
                backgroundColor: "#e8f5e8",
                color: "#2e7d32",
                px: 2,
                py: 0.5,
                borderRadius: 2,
                fontWeight: 600,
                fontSize: "0.85rem",
              }}
            >
              Yearly Plan
            </Typography>
          </Box>

          <Typography
            variant="subtitle2"
            align="center"
            sx={{
              mt: 2,
              fontSize: "0.95rem",
              color: "#555",
              fontWeight: 500,
            }}
          >
            Post up to{" "}
            <span style={{ color: "#1976d2" }}>{property_limit}</span> {" "}properties and{" "}
            <span style={{ color: "#1976d2" }}>{project_limit}</span> {" "}projects
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography
            variant="body2"
            align="center"
            color="text.secondary"
            sx={{
              fontSize: "0.9rem",
              lineHeight: 1.6,
              px: 1,
              whiteSpace: 'pre-line',
            }}
          >
            {plan.description}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default VendorSubscriptionPlan;